// Constants for buyerListing form
export const STEP_WEIGHTS = {
  buyerInfo: 11,
  location: 11,
  timeLine: 11,
  budget: 11,
  propertyType: 11,
  mustHaves: 11,
  niceToHaves: 11,
  purchaseType: 11,
  financing: 12,
};

export const LOCATION_KEYS = [
  "invalidLocation",
  "lat",
  "lng",
  "city",
  "state",
  "zip",
  "county",
  "mapRadius",
  "neighborHood",
  "highSchool",
  "isGitchaAvailable",
  "zipCode",
  "zipIdValues",
  "zipId",
  "forGitchaAvailablePopup",
  "location",
  "mapZoom",
  "mapImg",
];

export const BUDGET_KEYS = ["maxBdgt", "minBdgt"];

export const PROPERTY_TYPE_KEYS = [
  "prprtyType",
  "prptyTypeTxt",
  "prptySubTypes",
  "nice2Have",
  "noBedRm",
  "noBathRm",
  "noOfBeds",
  "sqFtMin",
  "sqFtMax",
  "grgSpce",
  "minLtSz",
  "maxLtSz",
  "yrBltMin",
  "yrBltMax",
  "isNwCnstctn",
  "acreageMin",
  "acreageMax",
  "lotType",
  "lotTypeText",
  "roadType",
  "rdTypText",
  "isPrvtDrInst",
  "onSiteElec",
  "waterSupply",
  "wSText",
  "isDrldWelInst",
  "wasteWtrSys",
  "wWSysText",
  "isSepTankInst",
  "isSepTankAppr",
  "prptySubTypes",
  "adaAccess",
  "accsPvtBthRm",
  "alwPets",
  "alwCats",
  "alwLrgDogs",
  "alwSmlDogs",
  "prptySubTypes",
  "adTitle",
  "adDesc",
  "minBdgt",
  "maxBdgt",
  "stories",
  "yearBuiltOption",
  "mnLtSzId",
  "mnLtSzTxt",
  "mxLtSzId",
  "mxLtSzTxt",
];
